<template>
    <div class="c-tag">
        <slot></slot>
        <svg class="c-tag__close" @click="$emit('remove', filter)" width="14" height="14" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="m13.4141 12 4.293-4.293a.9989.9989 0 0 0 0-1.414.9989.9989 0 0 0-1.414 0l-4.293 4.293-4.293-4.293a.9989.9989 0 0 0-1.414 0 .9989.9989 0 0 0 0 1.414L10.5861 12l-4.293 4.293a.9989.9989 0 0 0 0 1.414c.195.195.451.293.707.293.256 0 .512-.098.707-.293l4.293-4.293 4.293 4.293c.195.195.451.293.707.293.256 0 .512-.098.707-.293a.9989.9989 0 0 0 0-1.414L13.4141 12Z" id="a"/></defs><use fill="#212550" fill-rule="nonzero" xlink:href="#a"/></svg>
    </div>
</template>

<script>
export default {
    props: {
        filter: {
            required: true
        }
    }
}
</script>
